<template>
    <StepTemplate :activeStepNr="this.activeStepNr"
                  :myStepNr="this.myStepNr"
                  :value="value"

    >
        <template slot="slide-form">

            <form data-vv-scope="xxx" @click.alt="testFillForm()">
                <!--============================================================================================================-->
                <!--
                <v-layout row>
                    <v-flex xs11 class="mt-2"><h5>{{this.label}}</h5></v-flex>
                </v-layout>
                -->
                <!--============================================================================================================-->
                <v-layout row class="section_header">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>{{this.$options.label}}</h6></v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>

                <v-layout row>
                    <Rechner-hint-col>
                        Wie möchten Sie bezahlen?
                        <br>
                        <br>Auf Rechnung oder bequem per Lastschrifteinzug?

                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.bank_typ_zahlungsweg"
                                           v-model="value.fieldValues"
                                           direction="row"
                                           :$v="$v"
                        ></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <template v-if="value.fieldValues.bank_typ_zahlungsweg=='sepa'">
                    <v-layout row>
                        <v-flex xs11>
                            <h5>SEPA-Basis-Lastschrift-Mandat</h5>
                            Ich ermächtige/Der Kontoinhaber ermächtigt die Nordline Assecuranz AG, Zahlungen vom angegebenen Konto mittels Lastschrift einzuziehen. Zugleich weise ich/weist der Kontoinhaber das jeweilige Kreditinstitut an, die von der Nordline Assecuranz AG auf das angegebene Konto gezogenen Lastschriften einzulösen.
                            Ich bin/der Kontoinhaber ist damit einverstanden, dass der SEPA Basis-Lastschrift-Einzug dem Versicherungsnehmer spätestens einen Kalendertag vorab angekündigt wird.
                            Hinweis: Innerhalb von acht Wochen, beginnend mit dem Belastungsdatum kann die Erstattung des belasteten Betrages verlangt werden. Es gelten dabei die mit dem eigenen Kreditinstitut vereinbarten Bedingungen.
                            <br>
                            <br>
                            In Abweichung zu §33 Abs. 1 und §37 Abs. 2 VVG soll der Erst- oder Einmalbeitrag nicht erst fällig sein mit Ablauf der 14-tägigen Widerrufsfrist,
                            sondern unverzüglich nach Abschluss des Versicherungsvertrages, jedoch nicht vor dem mit Ihnen vereinbarten Beginn der Versicherung.
                            Dies gilt auch bei Abweichungen zwischen Antrag und Versicherungsschein nach §5 VVG.
                            <br>
                            <br>Name: Nordline Assecuranz AG
                            <br>Adresse: Goebenstrasse 10, 24534 Neumuenster
                            <br>Gläubiger Identifikationsnummer: DE07 ZZZ 0000 2524656
                            <br>Mandatsreferenz: Wird Ihre Versicherungsscheinnummer
                        </v-flex>
                    </v-layout>
                    <!--============================================================================================================-->
                    <v-layout row class="section_header">
                        <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Bank-Verbindung</h6></v-flex>
                    </v-layout>
                    <!------------------------------------------------------------------------------------------------------------>
                    <v-layout row>
                        <Rechner-hint-col>
                            Geben Sie hier Ihre IBAN korrekt und vollständig an!
                        </Rechner-hint-col>
                        <v-flex xs10>
                            <Rechner-field-col :fielddef="fieldDefs.bank_iban" v-model="value.fieldValues"
                                               :$v="$v"></Rechner-field-col>
                        </v-flex>
                    </v-layout>
                    <!------------------------------------------------------------------------------------------------------------>
                    <v-layout row>
                        <Rechner-hint-col>
                            Geben Sie hier den BIC Ihrer Bank vollständig an!
                        </Rechner-hint-col>
                        <v-flex xs10>
                            <Rechner-field-col :fielddef="fieldDefs.bank_bic" v-model="value.fieldValues"
                                               :$v="$v"></Rechner-field-col>
                        </v-flex>
                    </v-layout>
                    <!------------------------------------------------------------------------------------------------------------>
                    <v-layout row>
                        <Rechner-hint-col>
                            Geben Sie hier das Geldinstitut an!
                        </Rechner-hint-col>
                        <v-flex xs10>
                            <Rechner-field-col :fielddef="fieldDefs.bank_institut" v-model="value.fieldValues"
                                               :$v="$v"></Rechner-field-col>
                        </v-flex>
                    </v-layout>
                    <!------------------------------------------------------------------------------------------------------------>
                    <v-layout row>
                        <Rechner-hint-col>
                            Falls der Beitrag von einem anderen Konto als dem des Versicherungsnehmers abgebucht werden soll, geben Sie den Konto-Inhaber als abweichend an!
                        </Rechner-hint-col>
                        <v-flex xs10>
                            <Rechner-field-col :fielddef="fieldDefs.bank_inh_abweichend"
                                               v-model="value.fieldValues"
                                               direction="row"
                                               :$v="$v"
                            ></Rechner-field-col>
                        </v-flex>
                    </v-layout>
                    <template v-if="value.fieldValues.bank_inh_abweichend==1">
                        <!--============================================================================================================-->
                        <v-layout row class="section_header">
                            <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>abweichender Inhaber</h6></v-flex>
                        </v-layout>

                        <!------------------------------------------------------------------------------------------------------------>
                        <v-layout row>
                            <Rechner-hint-col>
                                Geben Sie hier den Konto-Inhaber an!
                            </Rechner-hint-col>
                            <v-flex xs10>
                                <Rechner-field-col :fielddef="fieldDefs.bank_inh_name" v-model="value.fieldValues"
                                                   :$v="$v"></Rechner-field-col>
                            </v-flex>
                        </v-layout>
                        <!------------------------------------------------------------------------------------------------------------>
                        <v-layout row>
                            <Rechner-hint-col>
                            </Rechner-hint-col>
                            <v-flex xs10>
                                <Rechner-field-col :fielddef="fieldDefs.bank_inh_strasse" v-model="value.fieldValues"
                                                   :$v="$v"></Rechner-field-col>
                            </v-flex>
                        </v-layout>
                        <!------------------------------------------------------------------------------------------------------------>
                        <v-layout row>
                            <Rechner-hint-col>
                            </Rechner-hint-col>
                            <v-flex xs3>
                                <Rechner-field-col :fielddef="fieldDefs.bank_inh_plz" v-model="value.fieldValues"
                                                   :$v="$v"></Rechner-field-col>
                            </v-flex>
                            <v-flex xs7>
                                <Rechner-field-col :fielddef="fieldDefs.bank_inh_ort" v-model="value.fieldValues"
                                                   :$v="$v"></Rechner-field-col>
                            </v-flex>
                        </v-layout>
                    </template>
                    <!------------------------------------------------------------------------------------------------------------>
                </template>
            </form>

        </template>
    </StepTemplate>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
  import slideMixin from '../stepMixin'
  import _ from 'lodash'

  //import {mapState} from 'vuex'

  export default {
    //========================================================================================================
    data: function () {

      //fieldDefs wird in StepMixin mit den Werten aus der Datenbank belegt,
      //an dieser Stelle können diese Werte überschrieben werden.
      // Vue merged von alleine die Werte aus 'stepMixin' und denen aus 'fieldDefs_OVERRIDE'
      var fieldDefs_OVERRIDE = {}

      return {
        fieldDefs: fieldDefs_OVERRIDE,
        frmValuesOld: {},


      }
    }, //========================================================================================================
    name: 'Step_BankVerb',
    label: 'Beitragszahlung',
    label2: 'Beitrags-<br>zahlung',
    fieldKeys: [
      'bank_typ_zahlungsweg',
      'bank_institut',
      'bank_inh_name',
      'bank_inh_abweichend',
      'bank_inh_strasse',
      'bank_inh_plz',
      'bank_inh_ort',
      'bank_iban',
      'bank_bic',
    ],

    //========================================================================================================
    watch: {
      value: {
        handler: function (newVal, oldVal) {
          console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
          console.log("WATCHER fieldValues in ", this.$options.label)
          var fV = this.value.fieldValues
          var fVold = this.frmValuesOld
          var earlyExit = true;
          for (var key in fV) {
            if (fV[key] !== fVold[key]) {
              earlyExit = false
              console.log("changed ", key, fVold[key], '->', fV[key])
              this.update_Ort_by_PLZ(key)
            }
          }
          if (earlyExit === true) {
            console.log("NO changes -> early EXIT")
            return;
          }

          /*------------------------------------------------------------------------------------*/
          if (fV.bank_typ_zahlungsweg !== 'sepa' && fV.bank_typ_zahlungsweg !== fVold.bank_typ_zahlungsweg) {
            this.value.fieldValues.bank_institut = '-/-';
            this.value.fieldValues.bank_inh_name = '-/-';
            this.value.fieldValues.bank_inh_abweichend = "0";
            this.value.fieldValues.bank_inh_strasse = '-/-';
            this.value.fieldValues.bank_inh_plz = '-/-';
            this.value.fieldValues.bank_iban = '-/-';
            this.value.fieldValues.bank_inh_ort = '-/-';
            this.value.fieldValues.bank_bic = '-/-';
            console.log("WATCHER: update  zahlungsweg: sepa OFF -> set all to -/-")
          }
          if (fV.bank_typ_zahlungsweg === 'sepa' && fV.bank_typ_zahlungsweg !== fVold.bank_typ_zahlungsweg) {
            this.value.fieldValues.bank_institut = null;
            this.value.fieldValues.bank_inh_name = null;
            this.value.fieldValues.bank_inh_abweichend = "0";
            this.value.fieldValues.bank_inh_strasse = '-/-';
            this.value.fieldValues.bank_inh_plz = '-/-';
            this.value.fieldValues.bank_inh_ort = '-/-';
            this.value.fieldValues.bank_iban = null;
            this.value.fieldValues.bank_bic = null;
            console.log("WATCHER: update  zahlungsweg: sepa ON -> set all to NULL")
          }
          /*------------------------------------------------------------------------------------*/
          if (parseInt(fV.bank_inh_abweichend, 10) === 0 && fV.bank_inh_abweichend !== fVold.bank_inh_abweichend) {
            this.value.fieldValues.bank_inh_name = '-/-';
            this.value.fieldValues.bank_inh_strasse = '-/-';
            this.value.fieldValues.bank_inh_plz = '-/-';
            this.value.fieldValues.bank_inh_ort = '-/-';
            /*
             this.value.fieldValues.bank_inh_name = this.allSteps.Step_VersNehmer.versnehm_vorname + ' ' + this.allSteps.Step_VersNehmer.versnehm_nachname;
             this.value.fieldValues.bank_inh_strasse = this.allSteps.Step_VersNehmer.versnehm_strasse;
             this.value.fieldValues.bank_inh_plz = this.allSteps.Step_VersNehmer.versnehm_plz;
             this.value.fieldValues.bank_inh_ort = this.allSteps.Step_VersNehmer.versnehm_ort;
             */
            console.log("WATCHER: update  inhab.abweich: OFF -> set all to Vers.Nehmer Data")
          }
          if (parseInt(fV.bank_inh_abweichend, 10) === 1 && fV.bank_inh_abweichend !== fVold.bank_inh_abweichend) {
            this.value.fieldValues.bank_inh_name = null;
            this.value.fieldValues.bank_inh_strasse = null;
            this.value.fieldValues.bank_inh_plz = null;
            this.value.fieldValues.bank_inh_ort = null;
            console.log("WATCHER: update inhab.abweich: ON -> set all to NULL")
          }
          /*------------------------------------------------------------------------------------*/
          this.frmValuesOld = _.assign({}, fV)
        },
        deep: true,

      },
    }, //===============================================================================================
    mixins: [slideMixin],
    //===========================================================================================================
    components: {
      /* programmatically setted by step-mixin*/
    }, //===========================================================================================================
    props: [/* programmatically setted by step-mixin*/],
    //===========================================================================================================
    // HOOKS:
    /* programmatically setted by step-mixin*/
    //===========================================================================================================
  }
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>

</style>
